import { createApp } from 'vue'
import TeikibinPopup from '~/js/components/teikibinPopup'

const CLASS_NAME_TEIKIBIN_RECORDS = 'js-teikibin-records'
const CLASS_NAME_TEIKIBIN_RECORDS_BLOCK = 'js-teikibin-records-block'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinRecords = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_RECORDS
  )
  if (!elementsTeikibinRecords.length) return

  Array.from(elementsTeikibinRecords).forEach((element) => {
    const blockAmount = Number(element.dataset.blockAmount) || 1
    const elementsTeikibinRecordsBlock = element.getElementsByClassName(
      CLASS_NAME_TEIKIBIN_RECORDS_BLOCK
    )
    Array.from(elementsTeikibinRecordsBlock).forEach((blockElement, index) => {
      if (index >= blockAmount) {
        blockElement.style.display = 'none'
      }
    })
    const hasMoreRecords = elementsTeikibinRecordsBlock.length > blockAmount
    createApp({
      name: 'SectionsTeikibinRecords',
      components: {
        TeikibinPopup,
      },
      data() {
        return {
          hasMoreRecords,
          isShow: {},
        }
      },
      methods: {
        showMore() {
          Array.from(elementsTeikibinRecordsBlock).forEach((blockElement) => {
            blockElement.style.display = null
          })
          this.hasMoreRecords = false
        },
      },
    }).mount(element)
  })
})
